import React, { FC } from 'react';
import { ProcurementsDisplay } from 'src/models/procurements/types';
import EmptyWorkspaceMessage from './EmptyWorkspaceMessage';
import EmptyScreeningMessage from './EmptyScreeningMessage';
import EmptyStarredMessage from './EmptyStarredMessage';
import styles from './index.module.scss';
import useOverviewMode from 'src/reactiveVars/overviewModeVar';

interface IProps {}

export const EmptyMessage: FC<IProps> = () => {
  const procurementTabInfo = useOverviewMode();

  return (
    <div className={styles.emptyMessage}>
      {procurementTabInfo?.tab === ProcurementsDisplay.WORKSPACE && <EmptyWorkspaceMessage />}
      {procurementTabInfo?.tab === ProcurementsDisplay.MATCHED && <EmptyScreeningMessage />}
      {procurementTabInfo?.tab === ProcurementsDisplay.MARKED && <EmptyStarredMessage />}
    </div>
  );
};

export default EmptyMessage;
